import { useReducer, useEffect, useContext, DependencyList } from 'react';
import { serviceReducerBase } from './serviceReducer';
import Context from '../../containers/App/MainProvider/context';
import { ApiStateBase, BasicAction } from '../../types';

function useService<T>(
  func: () => Promise<T>,
  extraReloadDeps: DependencyList = []
): [T | null, boolean, (data: T) => void, () => void] {
  const mainContext = useContext(Context);

  const typedReducer = (st: ApiStateBase<T>, action: BasicAction<T>) =>
    serviceReducerBase(st, action);
  const [state, dispatch] = useReducer(typedReducer, {
    loading: false,
    data: null,
  });

  const setData = (data: T) => {
    dispatch({ type: 'SUCCESS', payload: data });
  };
  const reload = () => {
    dispatch({ type: 'RELOAD' });
  };

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      dispatch({ type: 'INIT' });
      try {
        const data = await func();
        if (!didCancel) {
          dispatch({ type: 'SUCCESS', payload: data });
        }
      } catch (error) {
        if (!didCancel) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          mainContext.notifyError(error as any);
          dispatch({ type: 'FAIL' });
        }
      }
    };

    fetchData();
    return () => {
      didCancel = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, extraReloadDeps);

  return [state.data, state.loading, setData, reload];
}

export default useService;
